// object to store loaded and loading wasm modules
var installedWasmModules = {};

function promiseResolve() { return Promise.resolve(); }

var wasmImportedFuncCache0;
var wasmImportedFuncCache1;
var wasmImportedFuncCache2;
var wasmImportedFuncCache3;
var wasmImportedFuncCache4;
var wasmImportedFuncCache5;
var wasmImportedFuncCache6;
var wasmImportedFuncCache7;
var wasmImportedFuncCache8;
var wasmImportedFuncCache9;
var wasmImportedFuncCache10;
var wasmImportedFuncCache11;
var wasmImportedFuncCache12;
var wasmImportedFuncCache13;
var wasmImportedFuncCache14;
var wasmImportedFuncCache15;
var wasmImportedFuncCache16;
var wasmImportObjects = {
	734: function() {
		return {
			"./darklua_wasm_bg.js": {
				"__wbindgen_object_drop_ref": function(p0i32) {
					if(wasmImportedFuncCache0 === undefined) wasmImportedFuncCache0 = __webpack_require__.c[72574].exports;
					return wasmImportedFuncCache0["bk"](p0i32);
				},
				"__wbg_new_227d7c05414eb861": function() {
					if(wasmImportedFuncCache1 === undefined) wasmImportedFuncCache1 = __webpack_require__.c[72574].exports;
					return wasmImportedFuncCache1["mX"]();
				},
				"__wbg_stack_3b0d974bbf31e44f": function(p0i32,p1i32) {
					if(wasmImportedFuncCache2 === undefined) wasmImportedFuncCache2 = __webpack_require__.c[72574].exports;
					return wasmImportedFuncCache2["b9"](p0i32,p1i32);
				},
				"__wbg_error_a6fa202b58aa1cd3": function(p0i32,p1i32) {
					if(wasmImportedFuncCache3 === undefined) wasmImportedFuncCache3 = __webpack_require__.c[72574].exports;
					return wasmImportedFuncCache3["DL"](p0i32,p1i32);
				},
				"__wbg_performance_3fcf6e32a7e1ed0a": function(p0i32) {
					if(wasmImportedFuncCache4 === undefined) wasmImportedFuncCache4 = __webpack_require__.c[72574].exports;
					return wasmImportedFuncCache4["hx"](p0i32);
				},
				"__wbg_now_e7c6795a7f81e10f": function(p0i32) {
					if(wasmImportedFuncCache5 === undefined) wasmImportedFuncCache5 = __webpack_require__.c[72574].exports;
					return wasmImportedFuncCache5["sj"](p0i32);
				},
				"__wbindgen_object_clone_ref": function(p0i32) {
					if(wasmImportedFuncCache6 === undefined) wasmImportedFuncCache6 = __webpack_require__.c[72574].exports;
					return wasmImportedFuncCache6["BZ"](p0i32);
				},
				"__wbg_static_accessor_GLOBAL_THIS_8d1badc68b5a74f4": function() {
					if(wasmImportedFuncCache7 === undefined) wasmImportedFuncCache7 = __webpack_require__.c[72574].exports;
					return wasmImportedFuncCache7["KX"]();
				},
				"__wbg_static_accessor_SELF_146583524fe1469b": function() {
					if(wasmImportedFuncCache8 === undefined) wasmImportedFuncCache8 = __webpack_require__.c[72574].exports;
					return wasmImportedFuncCache8["lB"]();
				},
				"__wbg_static_accessor_GLOBAL_4ef717fb391d88b7": function() {
					if(wasmImportedFuncCache9 === undefined) wasmImportedFuncCache9 = __webpack_require__.c[72574].exports;
					return wasmImportedFuncCache9["ff"]();
				},
				"__wbg_static_accessor_WINDOW_f2829a2234d7819e": function() {
					if(wasmImportedFuncCache10 === undefined) wasmImportedFuncCache10 = __webpack_require__.c[72574].exports;
					return wasmImportedFuncCache10["xy"]();
				},
				"__wbg_stringify_b54333f60f1e4dad": function(p0i32) {
					if(wasmImportedFuncCache11 === undefined) wasmImportedFuncCache11 = __webpack_require__.c[72574].exports;
					return wasmImportedFuncCache11["N_"](p0i32);
				},
				"__wbg___wbindgen_throw_344f42d3211c4765": function(p0i32,p1i32) {
					if(wasmImportedFuncCache12 === undefined) wasmImportedFuncCache12 = __webpack_require__.c[72574].exports;
					return wasmImportedFuncCache12["F6"](p0i32,p1i32);
				},
				"__wbg___wbindgen_is_object_a27215656b807791": function(p0i32) {
					if(wasmImportedFuncCache13 === undefined) wasmImportedFuncCache13 = __webpack_require__.c[72574].exports;
					return wasmImportedFuncCache13["hi"](p0i32);
				},
				"__wbg___wbindgen_string_get_b0ca35b86a603356": function(p0i32,p1i32) {
					if(wasmImportedFuncCache14 === undefined) wasmImportedFuncCache14 = __webpack_require__.c[72574].exports;
					return wasmImportedFuncCache14["oF"](p0i32,p1i32);
				},
				"__wbg___wbindgen_is_undefined_c05833b95a3cf397": function(p0i32) {
					if(wasmImportedFuncCache15 === undefined) wasmImportedFuncCache15 = __webpack_require__.c[72574].exports;
					return wasmImportedFuncCache15["dF"](p0i32);
				},
				"__wbindgen_cast_0000000000000001": function(p0i32,p1i32) {
					if(wasmImportedFuncCache16 === undefined) wasmImportedFuncCache16 = __webpack_require__.c[72574].exports;
					return wasmImportedFuncCache16["NR"](p0i32,p1i32);
				}
			}
		};
	},
};

var wasmModuleMap = {
	"8699": [
		734
	]
};

// object with all WebAssembly.instance exports
__webpack_require__.w = {};

// Fetch + compile chunk loading for webassembly
__webpack_require__.f.wasm = function(chunkId, promises) {

	var wasmModules = wasmModuleMap[chunkId] || [];

	wasmModules.forEach(function(wasmModuleId, idx) {
		var installedWasmModuleData = installedWasmModules[wasmModuleId];

		// a Promise means "currently loading" or "already loaded".
		if(installedWasmModuleData)
			promises.push(installedWasmModuleData);
		else {
			var importObject = wasmImportObjects[wasmModuleId]();
			var req = fetch(__webpack_require__.p + "" + {"8699":{"734":"57b5dc2423ceb5643f56"}}[chunkId][wasmModuleId] + ".module.wasm");
			var promise;
			if(importObject && typeof importObject.then === 'function' && typeof WebAssembly.compileStreaming === 'function') {
				promise = Promise.all([WebAssembly.compileStreaming(req), importObject]).then(function(items) {
					return WebAssembly.instantiate(items[0], items[1]);
				});
			} else if(typeof WebAssembly.instantiateStreaming === 'function') {
				promise = WebAssembly.instantiateStreaming(req, importObject);
			} else {
				var bytesPromise = req.then(function(x) { return x.arrayBuffer(); });
				promise = bytesPromise.then(function(bytes) {
					return WebAssembly.instantiate(bytes, importObject);
				});
			}
			promises.push(installedWasmModules[wasmModuleId] = promise.then(function(res) {
				return __webpack_require__.w[wasmModuleId] = (res.instance || res).exports;
			}));
		}
	});
};